import api, { ApiResponse } from './api';
import type { Dashboard, DashboardConfig } from '../pages/dashboards/types';

export interface DashboardInput {
  name: string;
  description?: string | null;
  config: DashboardConfig;
  shared?: boolean;
}

export const dashboardsService = {
  list: async (): Promise<Dashboard[]> => {
    const res = await api.get<ApiResponse<Dashboard[]>>('/dashboards');
    return res.data.data!;
  },
  getById: async (id: string): Promise<Dashboard> => {
    const res = await api.get<ApiResponse<Dashboard>>(`/dashboards/${id}`);
    return res.data.data!;
  },
  create: async (input: DashboardInput): Promise<Dashboard> => {
    const res = await api.post<ApiResponse<Dashboard>>('/dashboards', input);
    return res.data.data!;
  },
  update: async (id: string, patch: Partial<DashboardInput>): Promise<Dashboard> => {
    const res = await api.put<ApiResponse<Dashboard>>(`/dashboards/${id}`, patch);
    return res.data.data!;
  },
  delete: async (id: string): Promise<void> => {
    await api.delete(`/dashboards/${id}`);
  },
};
